import React from 'react';
import { Link } from 'react-router-dom';

import { LargeLogo, LogoWrapper, SmallLogo } from './logo-section.style';

function LogoSection({
  isSidebarOpen,
  homePath,
}: {
  isSidebarOpen: boolean;
  homePath: string;
}): JSX.Element {
  return (
    <LogoWrapper>
      <Link to={homePath}>{isSidebarOpen ? <LargeLogo /> : <SmallLogo />}</Link>
    </LogoWrapper>
  );
}

export { LogoSection };
